// src/hooks/hooks.js

import { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

export function useWorkflowSteps(supplierId, orderId) {
  const [steps, setSteps] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supplierId || !orderId) {
      setSteps({});
      setLoading(false);
      return;
    }

    setLoading(true);

    const q = collection(
      db,
      "users",
      supplierId,
      "orders",
      orderId,
      "workflowSteps",
    );

    const unsub = onSnapshot(q, (snap) => {
      const map = {};
      snap.forEach((d) => {
        map[d.id] = { id: d.id, ...d.data() };
      });
      setSteps(map);
      setLoading(false);
    });

    return unsub;
  }, [supplierId, orderId]);

  return { steps, loading };
}

export function useDocuments(supplierId, orderId, stepId = null) {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    if (!supplierId || !orderId) {
      setDocs([]);
      return;
    }

    let q;

    if (stepId) {
      q = query(
        collection(db, "users", supplierId, "orders", orderId, "documents"),
        where("stepId", "==", stepId),
      );
    } else {
      q = collection(db, "users", supplierId, "orders", orderId, "documents");
    }

    const unsub = onSnapshot(q, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      arr.sort(
        (a, b) => (b.uploadedAt?.seconds || 0) - (a.uploadedAt?.seconds || 0),
      );
      setDocs(arr);
    });

    return unsub;
  }, [supplierId, orderId, stepId]);

  return docs;
}

export function useActivityLog(supplierId, orderId, stepId) {
  const [log, setLog] = useState([]);

  useEffect(() => {
    if (!supplierId || !orderId || !stepId) {
      setLog([]);
      return;
    }

    const q = query(
      collection(db, "users", supplierId, "orders", orderId, "activityLogs"),
      where("stepId", "==", stepId),
      orderBy("createdAt", "desc"),
    );

    const unsub = onSnapshot(q, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setLog(arr);
    });

    return unsub;
  }, [supplierId, orderId, stepId]);

  return log;
}